module.exports = __webpack_public_path__ + "img/TrashUndo.3bbe948c.png";